module.exports = __webpack_public_path__ + "img/color1-header.fcfc8dcf.png";